export default __webpack_public_path__ + "static/media/0000..0005.77bf6b15.png";